export const APP_INTERACTION_TYPES = {
    CALENDAR: "CALENDAR",
    LOCATION: "LOCATION",
    CAMERA: "PROFILE_IMAGE",
    BACK_PRESS: "BACK_PRESS",
    ACCESS_TOKEN: "ACCESS_TOKEN",
}

export const RECORDING_PROGRESS_COLORS = {
    defaultZone: "#8C8594",
    defaultZoneBackground: "#8c859457",
    greenZone: "#2BB792",
    greenZoneBackground: "#7cdbb757",
    orangeZone: "#FF6937",
    orangeZoneBackground: "#fc9f5b57",
}
export const RECORDING_PROGRESS_TIME = {
    maximum: 60,
    minimum: 30,
    almostDone: 15,
    done: 0,
}
export const AUDIO_ASSESSMENT_STAGE = {
    PRE_RECORDING: "pre-recording",
    COUNTDOWN: "countdown",
    RECORDING: "recording",
    RECORDING_SUCCESS: "recording-success",
}

export const INVOKED_SOURCE_KEY = "__jobInvokedSource__"

export const DOCUMENT_ASSESSMENT_STAGE = {
    UPLOAD_CTA_CLICK: "UPLOAD CTA CLICK",
    ADD_DOCUMENT_CLICK: "ADD DOCUMENT CLICK",
    DOCUMENT_REMOVED_CLICK: "DOCUMENT REMOVED CLICK",
    DOCUMENT_UPLOAD_INITIATED: "DOCUMENT UPLOAD INITIATED",
    DOCUMENT_UPLOAD_SUCCESS: "DOCUMENT UPLOAD SUCCESS",
    DOCUMENT_UPLOAD_FAILURE: "DOCUMENT UPLOAD FAILURE",
}

export const FILE_UPLOAD_SOURCE = {
    CAMERA: "CAMERA",
    GALLERY: "GALLERY",
    FILES: "FILES",
}
export const JOB_ID_KEY = "__jobId__"
export const JOB_DETAILS = "JOB DETAILS"

export const ASSEST_OPTION = {
    YES: "Yes",
    NO: "No",
}
